import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  FormBuilderQueryKeys,
  getFormBuilderList,
  type FormBuilderListQueryOptions,
} from "@/api/form-builder/formBuilder.queries";
import { useEntityTenantStore } from "@/store/entityTenantStore";

export const useFormBuilderList = (options: FormBuilderListQueryOptions) => {
  const entityTenant = useEntityTenantStore((state) => state.entityTenant);
  return useQuery({
    queryKey: [
      FormBuilderQueryKeys.list,
      entityTenant,
      options.page,
      options.pageSize,
      options.search,
      options.sortBy,
      options.sortOrder,
      options.filters,
    ],
    queryFn: ({ signal }) =>
      getFormBuilderList({ ...options, tenantId: entityTenant || undefined }, signal),
    placeholderData: keepPreviousData,
  });
};
